import { createAxiosInstance } from '@speechki-frontend/shared/axios';

import { toFormData } from '@speechki-frontend/shared/helpers/functions';

const URL = process.env.VUE_APP_BASE_URL;
const prefix = `/api/v2`;

const axios = createAxiosInstance(URL, { enableGuestAccess: true, rejectOn5xx: true });

export const fetchBook = (id, params = {}) => {
    return axios.get(`/api/v2/books/${id}/`, { params });
};

export const fetchBookLanguages = () => {
    return axios.get('/api/v2/books/book_languages/');
};

export const fetchLanguages = (params = { page_size: 1000 }) => {
    return axios.get('/api/v1/languages/languages/', { params });
};

export const fetchPauseConfigs = async (params = { page: 1, page_size: 20 }) => {
    const url = '/api/v2/pause_configs/';
    const { results = [] } = await axios.get(url, { params });
    return results;
};

export const uploadBook = (data, isManage = false) => {
    const url = isManage ? '/api/v2/admin/book/books/' : '/api/v2/books/';
    const formdata = toFormData(data);

    return axios.post(url, formdata);
};

export const fetchBookContents = bookId => {
    return axios.get(`${prefix}/books/${bookId}/contents/`);
};

export const deleteMultipleBookparts = (bookId, bookparts) => {
    return axios.delete(`${prefix}/books/${bookId}/delete/`, {
        params: {
            delete_ids: bookparts
        }
    });
};

export const reloadBook = (data, params = {}) => {
    return axios.patch(`/api/v2/books/${this.book.id}/reload/`, data, { params });
};

export const reindexBook = (book, params = {}) => {
    return axios.post(`${prefix}/books/${book}/reindex/`, {}, { params });
};

export const searchText = (book, search, params = {}) => {
    return axios.get(`${prefix}/books/${book}/search/`, {
        params: {
            ...params,
            search_part: search
        }
    });
};

export const deleteBook = (id, params = {}) => {
    return axios.delete(`${prefix}/books/${id}/`, { params });
};
